import {RootState} from "../../../../store";

export const getSpecialistsFindIsLoading = (state: RootState) => state.specialistsFindSliceReducer.isLoading;
export const getSpecialistsFindError = (state: RootState) => state.specialistsFindSliceReducer.error;
export const getSpecialistsFindData = (state: RootState) => state.specialistsFindSliceReducer.specialistsCollection;
export const getSpecialistsSelectionData = (state: RootState) => state.specialistsFindSliceReducer.selectionData;

export const getSpecialistsFind = (state: RootState) => state.specialistsFindSliceReducer;
export const getSpecialistsFindIsFallback = (state: RootState) => state.specialistsFindSliceReducer.isFallback;
